import { useState } from 'react'

import { useLocales } from 'src/contexts'

import { useGetColorThemeAndNext } from 'src/hooks/useGetColorThemeAndNext'
import { useIsMobile } from 'src/hooks/use-mobile'

import { getTableHeaders } from 'src/features/TableForContactsHistory/helpers'
import { FullServiceContactsProps } from 'src/api/ServiceContacts/types'

export const useContactsTableSection = () => {
  const { translations } = useLocales()
  const isMobile = useIsMobile()
  const { mainThemeColor } = useGetColorThemeAndNext()
  const hiddenOnMobile = isMobile ? 'hidden' : ''

  const [clickedContact, setClickedContact] =
    useState<FullServiceContactsProps>()
  const [isOpen, setIsOpen] = useState(false)

  const updateClickedContact = (
    updatedContact: FullServiceContactsProps,
  ): void => {
    if (clickedContact?.id !== updatedContact.id) return

    setClickedContact(updatedContact)
  }

  const handleContactClick = (contact: FullServiceContactsProps): void => {
    const selection = window.getSelection()

    if (selection && selection.toString().length > 0) {
      return
    }

    setClickedContact(contact)
    setIsOpen(true)
  }

  const handlePhoneClick = (
    event: React.MouseEvent,
    phoneNumber: string,
  ): void => {
    event.stopPropagation()
    window.location.href = `tel:${phoneNumber}`
  }

  const toggleModal = (): void => {
    setIsOpen(prev => !prev)
  }

  return {
    locale: translations.serviceContacts.historyServiceContacts,
    titles: translations.serviceContacts,
    tableHeaders: getTableHeaders(translations.serviceContacts),
    clickedContact,
    handleContactClick,
    toggleModal,
    isMobile,
    isOpen,
    hiddenOnMobile,
    updateClickedContact,
    handlePhoneClick,
    mainThemeColor,
  }
}
